import Icon from '../components/Icon.vue'

Icon.register({
  'kiwi-bird': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M575.8 218C572.6 157.4 518.3 112 457.6 112H448.3C395.4 112 344 95.8 300.5 65.8 258.5 36.8 204.5 24.1 147.3 37.1 129.3 41.1-0.1 78.2 0 224 0 294.9 38.7 356.8 96 390V464C96 472.8 103.2 480 112 480H128C136.8 480 144 472.8 144 464V409.7C159.3 413.7 175.4 416 192 416 197.4 416 202.7 415.3 208 414.8V464C208 472.8 215.2 480 224 480H240C248.8 480 256 472.8 256 464V404.6C270.2 399.5 283.9 393.2 296.3 385.1 342.1 355.3 393.9 336 448.5 336 473.9 336 464.5 335.7 471.5 335.2L545.9 471.7C548.8 476.9 554.2 480 560 480 561.3 480 562.6 479.8 563.9 479.5 571 477.7 576 471.3 576 464 576 464 576.1 223.8 575.8 218zM464 248C450.7 248 440 237.3 440 224 440 210.7 450.7 200 464 200S488 210.7 488 224C488 237.3 477.2 248 464 248zM544 401.3L504.1 328.2C519.2 322.3 532.8 313.6 544 302.2V401.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/kiwi-bird.js
// module id = jy/3
// module chunks = 144